export const layout = {
	spacing: {
		px: '2px',
		xs: '4px',
		s: '6px',
		sm: '8px',
		md: '12px',
		lg: '16px',
		xl: '20px',
		xxl: '24px',
		'3xl': '32px',
		'4xl': '36px',
		'5xl': '40px',
		'6xl': '48px'
	} as const,
	radii: {
		xs: '4px',
		sm: '8px',
		md: '12px',
		lg: '16px'
	} as const
};
